export const HOME = '/'
export const SUPERX = '/superx'
export const LOGIN_PERMISSION = "/login-permission";
export const CONTACT = "/enquiry-form";
export const ABOUTUS = "/about-us";
export const TANDC = "/terms";
export const REFUND_POLICY = "/refund";
export const COURSES = "/courses";
export const PLACEMENTS= "/placements";
export const COMPANIES= "/companies"
export const COURSEDETAILS = '/courses'
export const EVENTSDETAILS = '/event-details'
